<template>
  <router-link
    :to="{ name: linkName }"
    class="sidebar-item"
    :class="{ 'is-danger': isDanger, active: isActive, disabled: disabled }"
    @click="$emit('click')"
  >
  <b-icon pack="fas" :icon="icon" class="icon"></b-icon>
    <span class="label">{{ label }}</span>
  </router-link>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String, // Font Awesome icon class
      required: true,
    },
    linkName: {
      type: String, 
      required: "",
    },
    isDanger: {
      type: Boolean,
      default: false,
    },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    isActive() {
     return   this.$route.name === this.linkName
    },
  },
  methods: {
    handleClick() {
      if (this.disabled) return; // prevent interaction
      this.$emit("click");
    },
  },
};
</script>

<style scoped lang="scss">
.sidebar-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0.8rem;
  font-size: 0.95rem;
  color: #374151;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: #f9fafb;
  }

  &.active {
    background: #f3f4f6;
    font-weight: 600;
  }

  &.is-danger {
    color: #dc2626;

    &:hover {
      background: #fee2e2;
    }
    .label {
      color: #dc2626;
    }
  }

  &.disabled {
    color: #d1d5db;
    cursor: not-allowed;
    pointer-events: none; // prevents hover/click
    background: transparent;

    i {
      opacity: 0.6;
    }
    .label {
      opacity: 0.3;
    }
  }
}

.icon {
  width: 18px;
  text-align: center;
}
</style>
